import { animate, state, style, transition, trigger } from '@angular/animations';

export const scaleInOut = trigger('scaleInOut', [
  state('void', style({ opacity: 0, transform: 'scale(0.5)' })),
  transition('void => *', animate('200ms ease-in')),
  transition('* => void', animate('200ms ease-out')),
]);
